import storage from './storage'

// A chamada que o candidato escolheu.
//
// A mantenedora pode ter mais de uma aberta ao mesmo tempo — a do ano e a da EJA,
// por exemplo — e quem gerencia o título é ela. Guardamos só o id: o resto vem da
// API, que é quem sabe o que mudou.
const KEY = 'cpe-public-call-id'

const INFO_PREFIX = 'cpe-info:'
const LEGACY_INFO_KEY = 'cpe-info'
const NO_CHOICE = 'ultima'

const read = () => {
  try {
    return storage.getItem(KEY) || null
  } catch {
    return null
  }
}

let tabId = read()

const chosenId = () => tabId

const infoKey = () => `${INFO_PREFIX}${tabId || NO_CHOICE}`

const purgeInfo = (keep = infoKey()) => {
  try {
    const keys = []

    for (let i = 0; i < storage.length; i += 1) keys.push(storage.key(i))

    keys
      .filter(
        key =>
          key === LEGACY_INFO_KEY ||
          (key && key.startsWith(INFO_PREFIX) && key !== keep)
      )
      .forEach(key => storage.removeItem(key))
  } catch {}
}

const setChosen = id => {
  tabId = String(id)

  try {
    storage.setItem(KEY, tabId)
  } catch {}

  purgeInfo()
}

const clearChosen = () => {
  tabId = null

  try {
    storage.removeItem(KEY)
  } catch {}

  purgeInfo()
}

const switchedElsewhere = () => {
  const stored = read()

  return !!stored && stored !== tabId
}

let listeners = []

const notifySwitched = () => listeners.forEach(listener => listener())

const handleStorage = event => {
  if (event.key !== KEY && event.key !== null) return

  if (switchedElsewhere()) notifySwitched()
}

const onSwitch = listener => {
  if (listeners.length === 0) window.addEventListener('storage', handleStorage)

  listeners = [...listeners, listener]

  return () => {
    listeners = listeners.filter(item => item !== listener)

    if (listeners.length === 0) {
      window.removeEventListener('storage', handleStorage)
    }
  }
}

const publicCall = {
  chosenId,
  clearChosen,
  infoKey,
  notifySwitched,
  onSwitch,
  purgeInfo,
  setChosen,
  switchedElsewhere,
}

export default publicCall
